import { Grid } from '@mui/material'
import { yupResolver } from '@hookform/resolvers/yup'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'

import { FormContext } from '../Contexts'
import { FormHandleSubmit, GetSchemaValidation } from '../types'
import { TextFieldRegistered, TextMaskFieldRegistered } from '../Components'
import { ProfessionValidationSchema } from './ValidationSchemas'

export const ProfessionStep = ({
  id,
  data,
  setActiveForm,
}: {
  id: string
  data?: GetSchemaValidation<typeof ProfessionValidationSchema>
  setActiveForm: (handleSubmit: () => FormHandleSubmit<GetSchemaValidation<typeof ProfessionValidationSchema>>) => void
}) => {
  const { control, handleSubmit, register, setValue, watch, formState, getValues } = useForm({
    resolver: yupResolver(ProfessionValidationSchema),
    defaultValues: data,
  })

  useEffect(() => {
    setActiveForm(() => ({ formId: id, getData: getValues, submit: handleSubmit }))
  }, [getValues, handleSubmit, id, setActiveForm])

  return (
    <FormContext.Provider value={{ control, handleSubmit, register, setValue, watch, formState }}>
      <Grid container item spacing={2} rowSpacing={2}>
        {[...new Array(3)].map((_, index) => (
          <Grid container item xs={12} sm={12} md={12} key={index}>
            <Grid item xs={12} sm={6} md={6}>
              <TextFieldRegistered required={index === 0} name={`desiredJob.${index}.job`} label="Postulación para el cargo de" />
            </Grid>
            <Grid container item xs={12} sm={6} md={6}>
              <Grid item xs={12} sm={6} md={6}>
                <TextMaskFieldRegistered
                  label="Pretensión Salarial Mínima"
                  name={`desiredJob.${index}.salaryBegin`}
                  mask={'Gs. num'}
                  lazy={false}
                  blocks={{
                    num: {
                      mask: Number,
                      max: 999999999,
                      thousandsSeparator: '.',
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <TextMaskFieldRegistered
                  label="Pretensión Salarial Máxima"
                  name={`desiredJob.${index}.salaryEnd`}
                  mask={'Gs. num'}
                  lazy={false}
                  blocks={{
                    num: {
                      mask: Number,
                      max: 999999999,
                      thousandsSeparator: '.',
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </FormContext.Provider>
  )
}
